import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { Subscription } from 'rxjs';
import { ServicecallService } from 'src/app/services';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  @Input() clientList: any;
  forgotForm: FormGroup;
  forgotSubmitted: boolean = false;
  separateDialCode = false;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  searchSelection: any;
  errorMessage: any = null;

  private _fromDropDwn: string[] = ['empId', 'email', 'userName', 'number'];
  private _loading: boolean = false;
  private _resetPasswordSubscription: Subscription;

  
  constructor(
    private _router: Router,
    private _fb: FormBuilder,
    private _service: ServicecallService,
  ) {
    this.forgotForm = this._fb.group({
      domain: ['', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      empId: [''],
      email: [''],
      userName: [''],
      number: [''],
    });
  }

  ngOnInit(): void {
    this.searchDropdownChange({ value: 'employeeId' });
    // this.getTenant();
  }
  ngOnDestroy(): void {
    this._resetPasswordSubscription?.unsubscribe(); 
  }
  searchDropdownChange(option: any) {
    this.searchSelection = option.value;
    this._removeValidity();
    if (option.value === 'employeeId') {
      this._validateForm('empId');
    } else if (option.value === 'email') {
      this._validateForm('email');
    }
    else if (option.value === 'userName') {
      this._validateForm('userName');
    }
    else if (option.value === 'number') {
      this._validateForm('number');

    }
  }
  loadLoginForm() {
    this._router.navigate(['login']);
  }

  resetPassword() {
    this.forgotSubmitted = true;
    this._loading = true;
    if (this.forgotForm.invalid || (this.searchSelection === 'number' && !this.forgotForm.value.number)) {
      this._loading = false;
      return;
    }

    let phone = {
      countryCode: this.forgotForm.value.number?.dialCode,
      number: this.forgotForm.value.number?.number,
    }
    this._checkOrgValid(phone);
  }

  get forgotFormValues() {
    return this.forgotForm.controls;
  }

  private _validateForm(type: any) {
    type === 'email' ? this.forgotForm.controls[type].setValidators([Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]) :
      this.forgotForm.controls[type].setValidators([Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]);
    this.forgotForm.controls[type].updateValueAndValidity();
  }
  private _removeValidity() {
    this.forgotForm.patchValue({ ['email']: null, userName: null, number: null, empId: null });
    this._fromDropDwn.forEach(item => {
      this.forgotForm.controls[item].clearValidators();
      this.forgotForm.controls[item].updateValueAndValidity();
    });
  }
 
  // getTenant() {
  //   this.loading = true;
  //   this.service.getTenantDetails().subscribe((res: any) => {
  //     if (res['status']) {
  //       if (res['response'] && res['response']['response'].length > 0) {
  //         this.clientList = res['response']['response'];
  //       }
  //       this.loading = false;
  //     } else {
  //       this.loading = false;
  //     }
  //   });
  // }

  private _checkOrgValid(phone: any) {
    if (this.forgotForm.controls['domain'].value) {
      let client = this.clientList.find((x: any) => (x.domain).toLowerCase() === this.forgotForm.controls['domain'].value.toLowerCase())
      if (client) {
        localStorage.setItem("tenantId", client['_id']);
        const { userName, email, empId } = this.forgotForm.value;

        const reqPayload: {
          userName?: string;
          email?: string;
          empId?: string;
          phone?: any;
        } = {
          ...(userName && { userName }),
          ...(email && { email }),
          ...(empId && { empId }),
          ...(phone?.countryCode && phone?.number && { phone }),
        };
        this._resetPasswordSubscription = this._service.resetPassword(reqPayload).subscribe((resp: any) => {
          if (resp['status']) {
            if (resp['response']) {
              if (resp['response']['reset']) {
              } else {
                this._service.toasterService({ type: 'success', msg: resp["response"]["message"] });
                this.errorMessage = null;
                this.forgotForm.reset();
                this.loadLoginForm();
              }
            }
            this._loading = false;
          } else {
            this._service.toasterService({ type: 'error', msg: resp["response"]["message"] });
            this._loading = false;
          }
        });
      }
      else {
        this.errorMessage = 'Invaild Organisation';
        this._loading = false;
      }
    }
  }

  private _navigateToLaunch() {
    this._router.navigate(['/login']);
  }

}  
